import { createFileRoute } from '@tanstack/react-router';

import { useAuthFlash } from '@/features/auth/flash';
import { LoginForm } from '@/features/auth/LoginForm';

/** `/login?redirect=` —— 登入（含兩步驟驗證的第二步）。 */
export interface LoginSearch {
  redirect?: string;
}

function validateRedirectSearch(search: Record<string, unknown>): LoginSearch {
  // 只收字串；是否安全由 safeRedirect 在登入成功那一刻判斷（lib/auth/redirect.ts）。
  const redirect = search['redirect'];
  return typeof redirect === 'string' && redirect !== '' ? { redirect } : {};
}

export const Route = createFileRoute('/login')({
  validateSearch: validateRedirectSearch,
  component: LoginRoute,
});

function LoginRoute() {
  const { redirect } = Route.useSearch();
  const notice = useAuthFlash();
  return <LoginForm redirect={redirect} notice={notice} />;
}
